<template>
  <div class="ka-pc-spot-bar">
    <div
      v-for="item in items"
      :key="item.code"
      class="ka-pc-spot-item"
    >
      <div class="ka-pc-spot-name">{{ item.name }}</div>
      <div class="ka-pc-spot-row">
        <span class="ka-pc-spot-price">{{ item.formatted }}</span>
        <span class="ka-pc-spot-unit">{{ unitSuffix }}</span>
        <span
          v-if="item.change"
          :class="['ka-pc-badge', item.changeClass]"
        >{{ item.change }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpotPriceBar',
  props: {
    items: { type: Array, required: true },
    unitSuffix: { type: String, required: true }
  }
}
</script>
